<template>
  <a-row type="flex" justify="center" style="height: 5vh">
    <a-col class="team_index_bar_item">
      <router-link to="/team_en_m/partner">
        <div class="bar_item" tabindex="1">Senior Management</div>
      </router-link>
    </a-col>
    <a-col class="team_index_bar_item">
      <router-link to="/team_en_m/manager_adviser">
        <div class="bar_item" tabindex="2">Management Team</div>
      </router-link>
    </a-col>
    <a-col class="team_index_bar_item">
      <router-link to="/team_en_m/post_investment_operation">
        <div class="bar_item" tabindex="3">Operation Team</div>
      </router-link>
    </a-col>
  </a-row>
</template>

<script>

export default {
  name: 'Team_index_bar_en_m',
}
</script>

<style scoped>
.team_index_bar_item {
  background: grey;
  line-height: 5vh;
  margin: 0.1vw;
  width: 33vw;
}

.bar_item {
  color: white;
  font-size: 10px;
}

.bar_item:focus {
  background-color: #2f54eb;
}

</style>